export default from './LoanPayments';



// WEBPACK FOOTER //
// ./src/components/QuizPage/components/SummaryPage/components/LoanPayments/index.js